<template>
    <div class="peaTable">
      <el-table :data="tableData" @current-change="selectRow" :row-style="rowStyle" v-loading="tableLoading">
        <el-table-column align="left"
          prop="id"
          label="PEA No." width="120">
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
          prop="peaName"
          label="Name">
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
          v-if="type == 6"
          prop="approvedBy"
          label="Approved By">
          <template slot-scope="scope">
            <ul>
              <li v-for="name in scope.row.approvedBy" v-bind:key="name.id">{{ name }}</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
          v-if="type == 6"
          prop="stillToApprove"
          label="Pending Approval">
          <template slot-scope="scope">
            <ul>
              <li v-for="name in scope.row.stillToApprove" v-bind:key="name.id">{{ name }}</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
                         prop="dateCreated"
                         label="Created"
                         v-if="type == 7">
          <template slot-scope="props">
            {{ formatDate(props.row.dateCreated) }}
          </template>
        </el-table-column>
        <el-table-column align="left"
          prop="peaOwner"
          label="Raised By"
          v-if="type == 1 || type == 2">
        </el-table-column>
        <el-table-column align="left"
          prop="capitalBudget"
          label="Capital Budget ID"
          v-if="type == 1 || type == 2 || type == 4 || type == 5 || type == 7">
        </el-table-column>
        <el-table-column align="left"
          prop="totalExpenditure"
          label="Total Expenditure"
          v-if="type == 1 || type == 2 || type == 4 || type == 5 || type == 7">
          <template slot-scope="props">
            $ {{ callFormat(props.row.totalExpenditure)}}
          </template>
        </el-table-column>
        <el-table-column align="left"
          prop="costToDate"
          label="Cost to Date"
          v-if="type == 4">
          <template slot-scope="props">
            $ {{ callFormat(props.row.costToDate)}}
          </template>
        </el-table-column>
        <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
          prop="dateSubmitted"
          label="Date Submitted"
          v-if="type == 1 || type == 2 || type == 3 || type == 6">
          <template slot-scope="props">
            {{ formatDate(props.row.dateSubmitted) }}
          </template>
        </el-table-column>
        <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
          prop="authorizedDate"
          label="Approval Date"
          v-if="type == 3 || type == 4">
          <template slot-scope="props">
            {{ formatDate(props.row.authorizedDate) }}
          </template>
        </el-table-column>
        <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
          prop="projectStartDate"
          label="Project Start"
          v-if="type == 3">
          <template slot-scope="props">
            {{ formatDate(props.row.projectStartDate) }}
          </template>
        </el-table-column>
        <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
          prop="projectEndDate"
          label="Project End"
          v-if="type == 3 || type == 4">
          <template slot-scope="props">
            {{ formatDate(props.row.projectEndDate) }}
          </template>
        </el-table-column>
      </el-table>
      <br/>
      <el-pagination v-if="resultTotal > pageSize"
        @current-change="fetchData"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="resultTotal"
        background>
      </el-pagination>
    </div>
</template>

<script>
import router from '@/router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'welcome-table',
  props: {
    type: {
      default: 0
    }
  },
  data () {
    return {
      tableData: [{}],
      columns: Array,
      currentPage: 1,
      oldPage: 1,
      pageSize: 5,
      resultTotal: 0,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/getWelcomeData/' + this.type + '?page=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$axios.get(call).then((response) => {
        this.tableData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this.$parent.$parent.$parent, 'Error Retrieving Welcome table for type ' + this.type, reject.body, 'error', 30000)
      })
    },
    formatDate: function (entry) {
      return helperMethods.formatDate(entry)
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    },
    callFormat (number) {
      return helperMethods.formatMoney(number)
    },
    rowStyle () {
      return 'cursor: pointer;'
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    // watch for route change
    '$route': 'fetchData'
  }
}
</script>

<style>
.peaTable .cell {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
